<div class="container">
  <div class="navigation-bar">
    <div class="effect"></div>
    <button type="button" [class.active]="selectedMenuId === home?.id" (click)="clickMenuItem()">
      <i class="fas fa-home"></i>
    </button>
    <button type="button" [class.active]="selectedMenuId === 177" (click)="clickMenuItem(177)">
      <i class="fas fa-bullseye"></i>
    </button>
    <div class="favourite-wrapper">
      <div class="employee-favorite" role="button" tabindex="0" (click)="toggleMenu($event)" [class.disabled]="!favourites || !favourites.length" aria-haspopup="true" [attr.aria-expanded]="menuOpen">
        <span *ngIf="menuOpen" class="icon-transition advanced-animation">
          <i class="fa fa-times" style="font-size: 2rem"></i>
        </span>
        <span *ngIf="!menuOpen" class="icon-transition advanced-animation">
          <i class="far fa-bookmark" style="font-size: 2rem"></i>
        </span>
      </div>
      <ng-container *ngIf="favourites && favourites.length">
        <div class="bookmark-menu p-2" [class.show]="menuOpen" #menuContainer>
          <ng-container *ngFor="let favourite of favourites; let i = index">
            <button type="button" class="cursor-pointer position-relative" (click)="clickFavourite(favourite.menuItem)" [class.active]="selectedMenuId === favourite.menuItem?.id">
              <i class="far fa-bookmark"></i>
              <span class="favourite-number mt-1">{{ i + 1 }}</span>
            </button>
            <span>{{ favourite.label }}</span>
          </ng-container>
        </div>
      </ng-container>
    </div>
    <button type="button" [class.active]="selectedMenuId === 200" (click)="clickMenuItem(200)"><i class="fas fa-graduation-cap"></i></button>
    <button type="button" [class.active]="selectedMenuId === 1017" (click)="clickMenuItem(1017)">
      <i class="fas fa-comments"></i>
    </button>
  </div>
</div>
